import { Edition } from "@carnegie-learning/cure-types";
import { Action, createReducer, on } from "@ngrx/store";
import * as editionActions from "../actions/student-active-editions.action";

export interface StudentActiveEditionsState {
    entities: Map<string, Edition>;
    loading: boolean;
    loaded: boolean;
}

export const initialState: StudentActiveEditionsState = {
    entities: new Map<string, Edition>(),
    loading: false,
    loaded: false,
};

const editionReducer = createReducer(
    initialState,
    on(editionActions.LoadStudentActiveEditions, (state) => {
        return {
            ...state,
            loading: true,
            loaded: false,
        };
    }),
    on(editionActions.LoadStudentActiveEditionsFail, (state) => {
        return {
            ...state,
            loading: false,
            loaded: false,
        };
    }),
    on(
        editionActions.LoadStudentActiveEditionsSuccess,
        (state, { payload }) => {
            const activeEditions = payload.data;
            const entities = new Map<string, Edition>();
            activeEditions.forEach((activeEdition) => {
                entities.set(activeEdition.editionId, activeEdition);
            });
            return {
                ...state,
                loading: false,
                loaded: true,
                entities,
            };
        }
    )
);

export function reducer(
    state: StudentActiveEditionsState | undefined,
    action: Action
) {
    return editionReducer(state, action);
}

export const getActiveEditionsEntities = (state: StudentActiveEditionsState) =>
    state.entities;
export const getActiveEditionsLoading = (state: StudentActiveEditionsState) =>
    state.loading;
export const getActiveEditionsLoaded = (state: StudentActiveEditionsState) =>
    state.loaded;
